/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { ScheduleTemplate } from './ScheduleTemplate';
import {
    ScheduleTemplateFromJSON,
    ScheduleTemplateFromJSONTyped,
    ScheduleTemplateToJSON,
    ScheduleTemplateToJSONTyped,
} from './ScheduleTemplate';

/**
 * 
 * @export
 * @interface ListScheduleTemplatesResponse
 */
export interface ListScheduleTemplatesResponse {
    /**
     * 
     * @type {Array<ScheduleTemplate>}
     * @memberof ListScheduleTemplatesResponse
     */
    data: Array<ScheduleTemplate>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListScheduleTemplatesResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListScheduleTemplatesResponse interface.
 */
export function instanceOfListScheduleTemplatesResponse(value: object): value is ListScheduleTemplatesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListScheduleTemplatesResponseFromJSON(json: any): ListScheduleTemplatesResponse {
    return ListScheduleTemplatesResponseFromJSONTyped(json, false);
}

export function ListScheduleTemplatesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListScheduleTemplatesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ScheduleTemplateFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListScheduleTemplatesResponseToJSON(json: any): ListScheduleTemplatesResponse {
      return ListScheduleTemplatesResponseToJSONTyped(json, false);
  }

  export function ListScheduleTemplatesResponseToJSONTyped(value?: ListScheduleTemplatesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(ScheduleTemplateToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

